// src/schedule/rota-dates.js
//
// v136.8 (16 Oct 2026 audit) - rota dates that do not assume Monday.
//
// shifts.week_start is a MONDAY in the UAE and a SUNDAY in Qatar (docs/field-lessons.md "The Monday
// assumption"). Every date here comes from shiftDateStr in src/worker/balances-calc.js, which walks forward
// from whatever weekday week_start really is, so a UAE week gives exactly what the old Mon-first offset gave.
//
// Zero-dep apart from that pure helper, so the schedule bundle imports it and tests import this file straight.

import { shiftDateStr } from '../worker/balances-calc.js';

const UAE_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// The AI rota prompt's week line: 'Mon 2026-10-12 to Sun 2026-10-18' in the UAE (unchanged), and
// 'Sun 2026-10-11 to Sat 2026-10-17' for a Qatar week. displayDays: getDisplayDays() for the store.
export function aiWeekLabel(weekStart, displayDays) {
  const days = (Array.isArray(displayDays) && displayDays.length === 7) ? displayDays : UAE_DAYS;
  const first = days[0], last = days[6];
  return first + ' ' + shiftDateStr(weekStart, first) + ' to ' + last + ' ' + shiftDateStr(weekStart, last);
}

export { shiftDateStr as rotaDayDate };
